import {
  faCalendar,
  faChevronLeft,
  faChevronRight,
  faPercent,
  faPhone,
  faWrench,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { navigate } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useContext, useState } from 'react'
import AppContext from '../../context/context'
import { FormattedMessage } from 'react-intl'
import { useSwipeable } from 'react-swipeable'
import { t } from '../../../common/i18n'
import Camion from '../../assets/menu/icon_camion.svg'
import Coche from '../../assets/menu/icon_coche.svg'
import Moto from '../../assets/menu/icon_moto.svg'
import Neumaticos from '../../assets/menu/icon_neumaticos.svg'
import Revisiones from '../../assets/menu/icon_revision.svg'
import Agricola from '../../assets/menu/icon_tractor.svg'
import menuItems from '../../../specific/constants/menu'
import routePath from '../../utils/route'
import styles from './menuHeaderMobile.module.scss'
import { startCitaPrevia } from '../../context/actions/citaPreviaActions'
import { CitaPreviaEnum, citaPreviaSteps } from '../CitaPrevia/CitaPreviaSteps'
import Phone from '../../assets/phone.svg'
import HeaderMobileFooter from '../../../specific/components/headers/HeaderMobileFooter'

const icons = {
  neumaticos: <Neumaticos />,
  revision: <Revisiones className={styles.revision_icon} />,
  coches: <Coche />,
  moto: <Moto />,
  camion: <Camion />,
  agricola: <Agricola />,
  phone: <Phone />,
  calendar: <FontAwesomeIcon icon={faCalendar} />,
  percent: <FontAwesomeIcon icon={faPercent} />,
  wrench: <FontAwesomeIcon icon={faWrench} />,
  phoneIcon: <FontAwesomeIcon icon={faPhone} />,
}

const LinkMenu = ({ name, r, icon, close }) => {
  const onCloseMenu = (e, r) => {
    e.preventDefault()
    close()
    navigate(r)
  }
  if (!r) {
    return <FormattedMessage id={name} />
  }
  if (name === 'menuHeader.c-acceso') {
    return (
      <a
        className={styles.menu_title}
        href={r}
        target="_blank"
        rel="noreferrer">
        <div className={styles.name_icon}>
          <span className={styles.name2}>
            <FormattedMessage id={name} />
          </span>
        </div>
      </a>
    )
  }

  if (typeof r === 'string') {
    return (
      <a
        onClick={() => onCloseMenu(event, routePath(r))}
        className={styles.menu_title}
        href={routePath(r)}>
        <div className={styles.name_icon}>
          {icon ? icons[icon] : null}
          <span className={icon ? styles.name : styles.name2}>
            <FormattedMessage id={name} />
          </span>
        </div>
      </a>
    )
  }

  const { path, ...rest } = r
  return (
    <a
      onClick={() => onCloseMenu(event, routePath(path, rest))}
      className={styles.menu_title}
      href={routePath(path, rest)}>
      <span className={icon ? '' : styles.name2}>
        <FormattedMessage id={name} />
      </span>
    </a>
  )
}

const LinkDistributivas = ({ name, r, icon, close, text_mobile }) => {
  const onCloseMenu = (e, r) => {
    e.preventDefault()
    close()
    navigate(r)
  }
  if (!r) {
    return <FormattedMessage id={name} />
  }

  if (typeof r === 'string') {
    return (
      <a
        onClick={() => onCloseMenu(event, routePath(r))}
        className={styles.menu_title}
        href={routePath(r)}>
        <div className={styles.name_icon}>
          <span className={icon ? styles.name : ''}>
            {text_mobile ? (
              <FormattedMessage id={text_mobile} />
            ) : (
              <React.Fragment>
                {t('menuHeader.todo_sobre')}
                <FormattedMessage id={name} />
              </React.Fragment>
            )}
          </span>
        </div>
        <div className={styles.arrow_container}>
          <FontAwesomeIcon icon={faChevronRight} />
        </div>
      </a>
    )
  }

  const { path, ...rest } = r
  return (
    <a
      onClick={() => onCloseMenu(event, routePath(path, rest))}
      className={styles.menu_title}
      href={routePath(path, rest)}>
      <FormattedMessage id={name} />
    </a>
  )
}

LinkMenu.propTypes = {
  name: PropTypes.string.isRequired,
  r: PropTypes.any.isRequired,
  icon: PropTypes.string.isRequired,
  close: PropTypes.any,
}

const MenuLevel = ({
  selected,
  setSelected,
  path,
  name,
  submenu,
  route,
  icon,
  close,
  text_mobile,
}) => {
  const items = submenu || []
  const nSelected = selected.split('.').length
  const nActual = path.split('.').length

  if (nActual > nSelected + 1) {
    return null
  }
  if (nActual <= nSelected && !selected.startsWith(path)) {
    return null
  }

  if (items.length === 0) {
    return <LinkMenu close={close} name={name} r={route} icon={icon} />
  }
  return (
    <li className={styles.submenu}>
      {nActual === nSelected && (
        <a
          className={styles.back}
          href="#"
          onClick={(e) => {
            e.preventDefault()
            const p = path.split('.')
            p.pop()
            setSelected(p.join('.'))
          }}>
          <FontAwesomeIcon icon={faChevronLeft} className={styles.back_icon} />
          {t('atras')}
        </a>
      )}
      <a
        className={styles.menu_title}
        href="#"
        onClick={(e) => {
          e.preventDefault()
          setSelected(path)
        }}>
        <div className={styles.name_icon}>
          {icons[icon]}
          <span className={styles.name}>
            <FormattedMessage id={name} />
          </span>
        </div>
        {nActual > nSelected && (
          <div className={styles.arrow_container}>
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        )}
      </a>
      {items.length > 0 &&
        selected.startsWith(path) &&
        (selected === '0.1' ||
          selected === '0.2' ||
          selected === '0.3' ||
          selected === '0.4' ||
          selected === '0.5') &&
        (path === '0.1' ||
          path === '0.2' ||
          path === '0.3' ||
          path === '0.4' ||
          path === '0.5') && (
          <LinkDistributivas
            close={close}
            name={name}
            r={route}
            icon={icon}
            text_mobile={text_mobile}
          />
        )}

      {items.length > 0 && selected.startsWith(path) && (
        <ul className={styles.submenu_wrapper}>
          {items.map((i) => (
            <MenuLevel
              selected={selected}
              setSelected={setSelected}
              key={i.id}
              path={path + '.' + i.id}
              close={close}
              {...i}
            />
          ))}
        </ul>
      )}
      {path === '0.1.3' ? (
        <div className={styles.button_buscador_wrapper}>
          <button
            className={styles.button_buscador}
            onClick={() => navigate(routePath('selector.ancho'))}>
            <FormattedMessage id="menuHeader.buscador_neumatico" />
            <FontAwesomeIcon
              icon={faChevronRight}
              className={styles.button_buscador_icon}
            />
          </button>
        </div>
      ) : null}
      {path === '0.2.3' ? (
        <div className={styles.button_buscador_wrapper}>
          <button
            className={styles.button_buscador}
            onClick={() => navigate(routePath('revisiones.asistente'))}>
            <FormattedMessage id="menuHeader.asistente_revision" />
            <FontAwesomeIcon
              icon={faChevronRight}
              className={styles.button_buscador_icon}
            />
          </button>
        </div>
      ) : null}
    </li>
  )
}

MenuLevel.defaultProps = {
  route: '',
  icon: '',
  submenu: [],
}

MenuLevel.propTypes = {
  selected: PropTypes.string.isRequired,
  setSelected: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  submenu: PropTypes.array,
  route: PropTypes.any,
  icon: PropTypes.string,
  close: PropTypes.any,
}

interface Props {
  close?: () => void
  esPath: string
  caPath: string
}
const MenuHeaderMobile = ({ close, esPath, caPath }: Props) => {
  const [selected, setSelected] = useState('0')
  const [openModal, setOpenModal] = useState(false)
  const { dispatch } = useContext(AppContext)
  const handlers = useSwipeable({
    onSwipedUp: () => close(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
    delta: 70,
  })
  const site = process.env.GATSBY_WEB
  
  const goToCitaPrevia = () => {
    const url = document.location.pathname
    dispatch(startCitaPrevia(url))
    navigate(citaPreviaSteps[CitaPreviaEnum.SELECCION_TALLER].route)
  }
  return (
    <div {...handlers} className={styles.menu}>
      <ul className={ site == 'rodi' ? `${styles.menu_header_mobile} ${styles.rodi}` : styles.menu_header_mobile}>
        <div className={styles.menu_items_container}>
          {menuItems.menu.map((i) => (
            <MenuLevel
              close={close}
              selected={selected}
              key={i.id}
              setSelected={setSelected}
              path={'0.' + i.id}
              {...i}
            />
          ))}
        </div>
        <div className={styles.fillHeight} />
        <HeaderMobileFooter
          esPath={esPath}
          caPath={caPath}
          openModal={openModal}
          goToCitaPrevia={goToCitaPrevia}
          setOpenModal={setOpenModal}
        />
      </ul>
    </div>
  )
}

export default MenuHeaderMobile
